module.exports = __webpack_public_path__ + "static/media/advantage_4.f093a822.png";